import React from 'react';
import { motion } from 'framer-motion';
import { XIcon } from 'lucide-react';
const costs = ['Oltre 150 ore perse a decidere "cosa cucinare stasera".', 'Centinaia di euro buttati in cibo che scade e finisce nella spazzatura.', 'Energia zero: quel senso di pesantezza costante che rovina i tuoi pomeriggi.', 'Stress mentale: la frustrazione di ricominciare ogni lunedì senza una guida.'];
export function PainSection() {
  return <section className="py-10 sm:py-16 px-4 bg-brand-cream" data-id="element-134">
      <div className="max-w-xl mx-auto" data-id="element-135">
        <motion.h2 initial={{
        opacity: 0,
        y: 20
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true
      }} className="text-xl sm:text-3xl font-serif font-bold text-center mb-6 sm:mb-8 text-brand-text-main" data-id="element-136">
          Smetti di pagare con il tuo tempo e la tua salute.
        </motion.h2>

        <motion.p initial={{
        opacity: 0,
        y: 20
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true
      }} className="text-base sm:text-lg text-center text-brand-text-muted font-medium mb-6 sm:mb-8" data-id="element-137">
          Quanto ti costa ogni anno non avere un sistema organizzato?
        </motion.p>

        <div className="space-y-3 sm:space-y-4" data-id="element-138">
          {costs.map((cost, i) => <motion.div key={i} initial={{
          opacity: 0,
          x: -10
        }} whileInView={{
          opacity: 1,
          x: 0
        }} viewport={{
          once: true
        }} transition={{
          delay: i * 0.05
        }} className="flex gap-3 items-start bg-white p-4 sm:p-5 rounded-xl border border-brand-sage/30 shadow-sm" data-id="element-139">
              <div className="mt-0.5 bg-red-500/10 p-1.5 rounded-full shrink-0" data-id="element-140">
                <XIcon className="w-4 h-4 text-red-600" strokeWidth={3} data-id="element-141" />
              </div>
              <p className="text-sm sm:text-base text-brand-text-main font-medium leading-snug" data-id="element-142">
                {cost}
              </p>
            </motion.div>)}
        </div>

        <motion.p initial={{
        opacity: 0
      }} whileInView={{
        opacity: 1
      }} viewport={{
        once: true
      }} className="text-center text-base sm:text-lg font-bold text-brand-olive mt-8 italic" data-id="element-143">
          La soluzione non è una dieta restrittiva. È un sistema di
          organizzazione.
        </motion.p>
      </div>
    </section>;
}